<template lang="pug">
.product-carousel
  product-carousel(
    v-model='products_1',
    title='รถกอล์ฟไฟฟ้ายอดนิยม',
    swiperid='luuyjteter'
  )
  product-carousel(
    v-model='products_2',
    title='รถกอล์ฟโดยสาร',
    swiperid='iuyyttrerg'
  )
  product-carousel(
    v-model='products_3',
    title='รถชมวิวไฟฟ้า',
    swiperid='oputyutyu'
  )
</template>
<script>
import axios from '../axios'
import ProductCarousel from './ProductCarousel.vue'
export default {
  components: { ProductCarousel },

  data: () => ({
    products_1: [],
    products_2: [],
    products_3: [],
  }),

  mounted() {
    axios
      .get(
        'v1/product/search?subcat=164&subcat_type=subcat&per_page=9&orderby=menu_order'
      )
      .then(({ data }) => {
        this.products_1 = data.data
      })

    axios
      .get(
        'v1/product/search?subcat=168&subcat_type=subcat&per_page=9&orderby=menu_order'
      )
      .then(({ data }) => {
        this.products_2 = data.data
      })

    axios
      .get(
        'v1/product/search?subcat=172&subcat_type=subcat&per_page=9&orderby=menu_order'
      )
      .then(({ data }) => {
        this.products_3 = data.data
      })
  },
}
</script>

<style lang="scss" scoped>
.product-carousel {
  margin-top: -52px;

  @media (max-width: 575px) {
    margin-top: -40px;
  }
}
</style>

